<template>
  <div
    @mouseenter="mouseEnter = openOrCloseDropDown()"
    @mouseleave="false"
    :class="[{ 'mouse-enter': mouseEnter, 'mouse-leave': !mouseEnter }]"
    >
    <dropdown-menu
      id="drop-notifications-messages"
      v-model="mouseEnter"
      transition="translate-fade-down"
    >
      <md-button
        data-v-step="1"
        :md-ripple="false"
        md-elevation="0"
        class="md-icon-button dropdown-toggle notifications-button"
        @mouseleave="setNotifications()"
      >
        <md-icon v-if="numberOfMessages > 0">mark_unread_chat_alt</md-icon>
        <md-icon v-else>chat</md-icon>

      </md-button>
      <div
        class="notifications-number outside-number"
        v-if="numberOfMessages > 0"
      >
        {{ numberOfMessages }}
      </div>
      <md-content
        slot="dropdown"
        class="md-scrollbar my-drop"
        @click.native="close"
      >
        <SHeaderMessagesDropdown
          ref="messagesDropdown"
          :messages="messagesToDisplay"
          :extraMessages="extraMessages"
          :numberOfMessages="numberOfMessages"
        />
      </md-content>
    </dropdown-menu>
  </div>
</template>

<script>
import DropdownMenu from "@innologica/vue-dropdown-menu";
import SHeaderMessagesDropdown from "@/material-components/molecules/SHeaderMessagesDropdown.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import Global from "@/constants/Global";
export default {
  name: "SHeaderMessages",
  mixins: [UserHelperVue, ChatHelperVue, ItemHelperVue],
  components: {
    DropdownMenu,
    SHeaderMessagesDropdown,
  },
  data() {
    return {
      show: false,
      mouseEnter: false,
      hoverTime: 2,
      wasPopupHovered: false,
    };
  },
  methods: {
    close() {
      this.$emit("changeKey");
    },
    setMessagesAsSeen() {
      const contacts = this.messages;
      let allUnseenMessages = [];

      contacts.forEach((contact) => {
        const messages = contact.messages;
        const unseenMessages = messages.filter((msg) => msg.seen === 0);
        allUnseenMessages = [...allUnseenMessages, ...unseenMessages];
      });
    },
    setNotifications() {
      this.wasPopupHovered = true;
      this.setMessagesAsSeen();
    },
    openOrCloseDropDown() {
      return !Global.checkDevice();
    },
  },
  computed: {
    messages() {
      if (!this.userMessages) return [];
      const userMessages = this.userMessages || [];
      if (!Array.isArray(userMessages)) return [];
      const filteredMessages = userMessages.filter((element) => {
        if (!Array.isArray(element.messages)) return [];
        return this.getNewestMsgFromSender(element.messages);
      });
      const sortedMessages = [...filteredMessages].sort((a, b) => {
        const dateA = new Date(this.getLastMsgTimeStamp(a.messages));
        const dateB = new Date(this.getLastMsgTimeStamp(b.messages));
        return dateB - dateA;
      });
      const unreadMessages = sortedMessages.filter((msg) => {
        return this.isChatUnread(msg.messages);
      });
      return unreadMessages;
    },
    messagesToDisplay() {
      if (this.messages.length > 2) {
        const aux = this.messages.slice(0, 2);
        return aux;
      }
      return this.messages;
    },
    extraMessages() {
      if (this.messages.length > 2) {
        return this.messages.length - 2;
      }
      return 0;
    },
    numberOfMessages() {
      return this.messages.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.md-button {
  background-color: $primary;
}
.notifications-button {
  height: 42px;
  width: 42px;
}
@media screen and (min-width: 480px) {
  .notifications-button {
    width: 46px;
    height: 46px;
  }
}
@media screen and (min-width: 720px) {
  .notifications-button {
    width: 50px;
    height: 50px;
  }
}
</style>

<style lang="scss" scoped>
.md-button {
  border: 1px solid #e0e0e0;
  border-radius: 5px !important;
}
.md-icon {
  color: $white !important;
}
</style>

<style lang="scss" scoped>
.dropdown-item {
  margin-top: 0.4rem;
  cursor: pointer;
}
.outside-number {
  position: absolute;
  top: 68%;
  right: 0%;
  z-index: 1;
}
</style>

<style lang="scss" scoped>
.my-drop::before {
  position: absolute;
  content: "";
  top: -1px;
  left: 243px;
  transform: translateY(-100%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid $primary;
}
</style>

<!-- Header drop menu style -->
<style lang="scss">
#drop-notifications-messages .show {
  width: 280px !important;
  margin-top: 0.95em;
  border: 1px solid $primary;
  left: -229px !important;
}
#drop-notifications-messages a {
  color: $black !important;
}
#drop-notifications-messages span {
  margin-left: 0.5rem;
  text-align: center;
  font-size: 14px;
  letter-spacing: 1.25px;
}

#drop-notifications-messages a:active {
  background-color: $primary;
}
#drop-notifications-messages .dropdown-item:active {
  background-color: $primary;
}
</style>

<style lang="scss" scoped>
.md-icon-button {
  margin: 0;
}
.md-content {
  width: 275px;
  max-height: 400px;
}
</style>

<style lang="scss">
.dropdown-item {
  cursor: pointer;
}
.message-content,
.action-content {
  display: flex;
  flex-direction: column;
}
.container-message,
.container-request-item {
  display: flex;
  margin-top: 0.2rem;
  flex-wrap: nowrap;
}
.no-message {
  display: block;
  padding: 20px;
  margin-left: 0 !important;
}
#activity-link,
#message-link {
  color: rgba(0, 0, 0, 0.4) !important;
}
#activity-link:hover,
#message-link:hover {
  color: $primary !important;
}
.notifications-number {
  background-color: $danger;
  color: $white;
  width: 20px;
  border-radius: 10px;
  text-align: center;
  margin-left: 0.3rem;
}
</style>
